import { render, staticRenderFns } from "./SettlementHistory.vue?vue&type=template&id=b1d03624&scoped=true&"
import script from "./SettlementHistory.vue?vue&type=script&lang=js&"
export * from "./SettlementHistory.vue?vue&type=script&lang=js&"
import style0 from "./SettlementHistory.vue?vue&type=style&index=0&id=b1d03624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d03624",
  null
  
)

export default component.exports